// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2e74s","colMaxWidth":"Table_colMaxWidth__2pxVH"};